<template>
  <v-btn
    ref="slider_btn"
    v-bind="$attrs"
    :class="[
      $style.navigationBtn,
      $style.nextBtn,
      $style[position]
    ]"
    small
    fab
    depressed
    color="rgba(212, 32, 50, .25)"
  >
    <v-icon color="#fff">
      {{ `mdi-chevron-${position}` }}
    </v-icon>
  </v-btn>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SliderBtn extends Vue {
  @Prop({ type: String, default: '' })
  position!: 'left' | 'right'
}
</script>

<style module lang="scss">
.navigationBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  &:hover{
    color: #ed1b2f;
    opacity: 1;
  }
}

.left {
  left: 24px;
}

.right {
  right: 24px;
}
</style>
